module.exports = __webpack_public_path__ + "img/instagram.3dce9e5e.svg";